/**
 * theme/radii.ts
 * Corner radii. The design uses six values and no others.
 */
export const radii = {
  /** Buttons and inputs. */
  control: 5,
  /** Small boxes — segmented-control track, inline note boxes. */
  box: 6,
  /** Cards with a header strip and a table body. */
  card: 8,
  /**
   * KPI and chart cards. The design really does use 9px for these and 8px for
   * table cards — a single-block card reads slightly softer than one with a
   * header rule across it.
   */
  cardBlock: 9,
  /** Large cards, modals, drawer panels. */
  cardLg: 10,
  /** Modal shell. */
  modal: 10,
  /** Numbered circles in onboarding / empty states. */
  numberCircle: 11,
  /** Pills, status chips, progress bars. */
  pill: 999,
} as const;
